import { DateTime } from 'luxon';
import { Instance, types } from 'mobx-state-tree';

import Grade from '../GradeBooks/Grade';
import ClientScheduleLesson from './ClientScheduleLesson';

const ClientGradeBook = types
	.model('ClientGradeBook', {
		id: types.identifierNumber,
		final_grade: types.optional(types.string, ''),
		final_comment: types.maybeNull(types.string),
		gb_date: types.maybeNull(types.string),
		location_id: types.maybeNull(types.number),
		general_gradebook_id: types.maybeNull(types.number),
		grades: types.optional(types.array(Grade), []),
		is_done: types.number,
		is_present: types.maybeNull(types.number),
		manual_grade: types.optional(types.string, ''),
		schedule_lesson: types.maybeNull(ClientScheduleLesson),
		student_id: types.maybeNull(types.number),
		topic_schedule_id: types.maybeNull(types.number),
		is_show_final_comment: types.optional(types.boolean, true),
	})
	.volatile(() => ({
		loading: false,
	}))
	.views((self) => ({
		get dateTime() {
			return DateTime.fromSQL(self.gb_date);
		},
	}));

export default ClientGradeBook;

export interface IClientGradeBookModel extends Instance<typeof ClientGradeBook> {}
